import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import useIsAdminRole from '../../hooks/useIsAdminRole';
import { useOuterClick } from '../../hooks/useOuterClick';
import { ROUTE_INFO } from '../route/Route.constants';
import ArrowsIcon from './ArrowsIcon';
import CheckMarkIcon from './CheckMarkIcon';
import { RoleSwitchType } from './Common.types';
import { getUserInfo } from './Common.utils';

export default function RolesSwitch() {
  const [translation] = useTranslation();
  const [isDropdownOpened, setIsDropdownOpened] = useState(false);
  const { pathname: currentPath } = useLocation();
  const isAdminRole = useIsAdminRole();
  const oidcUser = getUserInfo();

  const ROLES: RoleSwitchType[] = [
    {
      label: translation('ADMINISTRATOR').toUpperCase(),
      value: translation('ADMINISTRATOR').toUpperCase(),
      path: ROUTE_INFO.adminDashboard.path,
    },
    {
      label: translation('REPORT_USER').toUpperCase(),
      value: translation('REPORT_USER').toUpperCase(),
      path: ROUTE_INFO.userDashboard.path,
    },
  ];

  const openDropdown = (): void => {
    setIsDropdownOpened(true);
  };

  const closeDropdown = (): void => {
    setIsDropdownOpened(false);
  };

  const handleClickOutside = (): void => {
    closeDropdown();
  };

  const innerRef = useOuterClick(handleClickOutside);
  const currentRole = ROLES.find((role) => role.path === currentPath);

  if (!isAdminRole || !currentRole) {
    return null;
  }

  const adminName = oidcUser?.profile.FullName;

  return (
    <div className="relative" ref={innerRef}>
      <div
        className="flex flex-row items-center cursor-pointer"
        onClick={openDropdown}
      >
        <div className="flex flex-col mr-50px">
          <div className="text-header-parameter text-14px font-semibold">
            {adminName}
          </div>
          <div className="text-header-parameter text-12px font-bold opacity-50">
            {currentRole?.label}
          </div>
        </div>
        <ArrowsIcon />
      </div>
      {isDropdownOpened && (
        <div className="flex flex-col px-24px bg-field-grey rounded-2px border border-roles-section-borer absolute z-50 top-0 right-1 py-1 shadow-lg w-auto">
          {ROLES.map((role) => {
            const { label, path } = role;
            const isSelected = path === currentPath;
            return (
              <Link
                to={path}
                className="flex flex-row items-center cursor-pointer py-9px justify-between"
                key={role.value}
              >
                <div className="flex flex-row items-center">
                  <div className={`${!isSelected && 'opacity-0'} mr-5`}>
                    <CheckMarkIcon />
                  </div>
                  <div className="flex flex-col mr-50px">
                    <div className="text-header-parameter text-14px font-semibold whitespace-nowrap">
                      {adminName}
                    </div>
                    <div className="text-header-parameter text-12px font-bold opacity-50">
                      {label}
                    </div>
                  </div>
                </div>
                <div className={`${!isSelected && 'opacity-0'}`}>
                  <ArrowsIcon />
                </div>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
